// extracted by mini-css-extract-plugin
export default {"movesAndScoreContainer":"styles_movesAndScoreContainer__nC+Cn","contentWrapper":"styles_contentWrapper__SXPpm","label":"styles_label__AOcAX"};